import React from 'react';
import { motion } from 'framer-motion';
type Variant = 'nodes' | 'orbit' | 'timeline' | 'grid' | 'workflow' | 'bloom' | 'calm';
export function MolecularBackdrop({
  variant
}: {
  variant: Variant;
}) {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 opacity-60" data-id="element-43">
      {variant === 'nodes' && <motion.svg width="100%" height="100%" viewBox="0 0 400 800" preserveAspectRatio="xMidYMid slice" data-id="element-44">
          <motion.circle cx="200" cy="300" r="180" stroke="#0085bd" strokeWidth="1" fill="none" opacity="0.25" animate={{
        rotate: 360
      }} transition={{
        duration: 30,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        transformOrigin: '200px 300px'
      }} data-id="element-45" />
          <motion.circle cx="200" cy="300" r="130" stroke="#0085bd" strokeWidth="1" fill="none" strokeDasharray="4 6" opacity="0.3" animate={{
        rotate: -360
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        transformOrigin: '200px 300px'
      }} data-id="element-46" />
          <circle cx="200" cy="300" r="5" fill="#0085bd" opacity="0.5" data-id="element-47" />
          <circle cx="80" cy="180" r="3" fill="#0085bd" opacity="0.4" data-id="element-48" />
          <circle cx="340" cy="420" r="3" fill="#0085bd" opacity="0.4" data-id="element-49" />
          <circle cx="320" cy="180" r="3" fill="#0085bd" opacity="0.4" data-id="element-50" />
          <circle cx="80" cy="420" r="3" fill="#0085bd" opacity="0.4" data-id="element-51" />
          <path d="M200 300 L80 180 M200 300 L340 420 M200 300 L320 180 M200 300 L80 420" stroke="#0085bd" strokeWidth="1" opacity="0.2" data-id="element-52" />
        </motion.svg>}

      {variant === 'orbit' && <motion.svg width="100%" height="100%" viewBox="0 0 400 800" preserveAspectRatio="xMidYMid slice" data-id="element-53">
          <motion.g animate={{
        rotate: 360
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        transformOrigin: '200px 400px'
      }} data-id="element-54">
            <ellipse cx="200" cy="400" rx="180" ry="60" stroke="#0085bd" strokeWidth="1.5" fill="none" opacity="0.3" data-id="element-55" />
            <circle cx="380" cy="400" r="5" fill="#0085bd" opacity="0.6" data-id="element-56" />
          </motion.g>
          <motion.g animate={{
        rotate: -360
      }} transition={{
        duration: 30,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        transformOrigin: '200px 400px'
      }} data-id="element-57">
            <ellipse cx="200" cy="400" rx="60" ry="180" stroke="#005072" strokeWidth="1.5" fill="none" opacity="0.25" data-id="element-58" />
            <circle cx="200" cy="220" r="4" fill="#005072" opacity="0.6" data-id="element-59" />
          </motion.g>
          <circle cx="200" cy="400" r="10" fill="#0085bd" opacity="0.5" data-id="element-60" />
        </motion.svg>}

      {variant === 'timeline' && <motion.svg width="100%" height="100%" viewBox="0 0 400 800" preserveAspectRatio="xMidYMid slice" data-id="element-61">
          <line x1="0" y1="400" x2="400" y2="400" stroke="#0085bd" strokeWidth="1" opacity="0.3" data-id="element-62" />
          <motion.circle r="5" fill="#0085bd" opacity="0.7" animate={{
        cx: [0, 400]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} cy="400" data-id="element-63" />
          {[80, 160, 240, 320].map((x, i) => <circle key={i} cx={x} cy="400" r="3" fill="#0085bd" opacity="0.4" data-id="element-64" />)}
        </motion.svg>}

      {variant === 'grid' && <div className="w-full h-full relative" style={{
      backgroundImage: 'linear-gradient(rgba(0, 133, 189, 0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 133, 189, 0.08) 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-65">
          <motion.div className="absolute w-full h-[2px] bg-minerva-blue/40 blur-[2px]" animate={{
        y: [0, 800]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-66" />
        </div>}

      {variant === 'workflow' && <motion.svg width="100%" height="100%" viewBox="0 0 400 800" preserveAspectRatio="xMidYMid slice" data-id="element-67">
          <path d="M50 200 C 150 200, 250 400, 350 400" stroke="#0085bd" strokeWidth="1.5" fill="none" strokeDasharray="5 6" opacity="0.35" data-id="element-68" />
          <path d="M50 600 C 150 600, 250 400, 350 400" stroke="#0085bd" strokeWidth="1.5" fill="none" strokeDasharray="5 6" opacity="0.35" data-id="element-69" />
          <motion.circle r="5" fill="#0085bd" opacity="0.7" animate={{
        cx: [50, 350],
        cy: [200, 400]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-70" />
          <motion.circle r="5" fill="#0085bd" opacity="0.7" animate={{
        cx: [50, 350],
        cy: [600, 400]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} data-id="element-71" />
          <circle cx="350" cy="400" r="6" fill="#0085bd" opacity="0.5" data-id="element-72" />
        </motion.svg>}

      {variant === 'bloom' && <motion.div className="absolute inset-0 flex items-center justify-center" initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 2,
      ease: 'easeOut'
    }} data-id="element-73">
          <motion.div className="w-[400px] h-[400px] rounded-full bg-minerva-blue/25 blur-[80px]" animate={{
        scale: [1, 1.15, 1]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-74" />
          <div className="absolute w-[250px] h-[250px] rounded-full bg-minerva-cyan/20 blur-[50px]" data-id="element-75" />
          <motion.svg className="absolute" width="320" height="320" viewBox="0 0 320 320" animate={{
        rotate: 360
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-76">
            <circle cx="160" cy="160" r="120" stroke="#0085bd" strokeWidth="1" fill="none" opacity="0.4" strokeDasharray="3 8" data-id="element-77" />
            <circle cx="160" cy="160" r="80" stroke="#0085bd" strokeWidth="1" fill="none" opacity="0.3" data-id="element-78" />
          </motion.svg>
        </motion.div>}

      {variant === 'calm' && <div className="absolute inset-0 flex items-center justify-center" data-id="element-79">
          <motion.div className="w-[500px] h-[500px] rounded-full bg-minerva-blue/15 blur-[100px]" animate={{
        scale: [1, 1.1, 1],
        opacity: [0.6, 0.9, 0.6]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-80" />
        </div>}
    </div>;
}